import {gql} from '@apollo/client';

export const GET_PICKUP_TASK_DETAIL = gql`
  query GetPickupTaskDetail($taskId: String!) {
    getPickupTaskDetail(taskId: $taskId) {
      id
      taskNumber
      taskDate
      warehouseId
      routeId
      accountId
      vehicleId
      vehicleModelId
      vehicleModelName
      vehicleTypeId
      startPointType
      startPointValue
      startPointName
      endPointType
      endPointValue
      endPointName
      status
      expDepartureTime
      actDepartureTime
      expCompleteTime
      actCompleteTime
      expDepartureTimeAt
      actDepartureTimeAt
      expCompleteTimeAt
      actCompleteTimeAt
    }
  }
`;